// symplr wants to override the font color on the "Total value" $ label
// so that it is white and thus easier to read on their colors.

// This chart also rotates the x-axis labels by 55 degrees instead of 45 degrees so that the very long text
// for PDM benefit 1 doesn't overlap with the benefit 2 text.

import AbstractChart from '../../abstract_chart';

class BenefitsWaterfallChart extends AbstractChart {
  options() {
    return $.extend(true, this.defaultOptions(), this.standard_waterfall_options(), this.custom_waterfall_options());
  }

  standard_waterfall_options() {
    const that = this; // for formatter() below
    return {
      chart: {
        height: 500,
        name: 'Benefits',
        type: 'waterfall',
      },
      legend: { enabled: false },
      series: this.createSeries(),
      tooltip: {
        formatter() {
          return `${this.key}: ${accounting.formatMoney(this.y.toFixed(0), that.model.currency_symbol(), 0, that.model.currency_thousand_separator(), that.model.currency_decimal_separator())}`;
        },
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      xAxis: {
        labels: {
          rotation: -55,
          style: { textOverflow: 'none' },
        },
        type: 'category'
      },
      yAxis: {
        labels: {
          overflow: 'justify'
        },
        title: { text: that.model.currency_code() }, // TODO - update this
      }
    };
  }

  // can be overridden by child classes to implement custom options
  custom_waterfall_options() {
    return {};
  }

  createSeries() {
    const that = this; // for formatter() below
    return [{
      data: this.createData(),
      dataLabels: {
        enabled: true,
        formatter() {
          if (this.key === 'Total value') {
           return `<span style="color: #FFFFFF;">${accounting.formatMoney((this.y / 1000).toFixed(0), that.model.currency_symbol(), 0, that.model.currency_thousand_separator(), that.model.currency_decimal_separator())}k</span>`;
          }

          return `${accounting.formatMoney((this.y / 1000).toFixed(0), that.model.currency_symbol(), 0, that.model.currency_thousand_separator(), that.model.currency_decimal_separator())}k`;
        }
      },
      pointPadding: 0
    }
    ];
  }

  createData() {
    const data = [];
    let total = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const benefit of Array.from(this.model.cumulative_value_by_benefit_for_chart(null, true))) {
      total += benefit[1];
      data.push({ name: benefit[0], y: benefit[1] });
    }

    data.push({ name: 'Total value', y: total, isIntermediateSum: true });
    return data;
  }
}

export default BenefitsWaterfallChart;
